// none for realtime, embedded in page
function NavRealtime() {
    return <></>;
}

export default NavRealtime;
